<div class="date-wrapper" [class.disabled]="control.disabled">
    <label [for]="'date-input-' + label">
        {{ label }}
        @if (required) {
<span class="text-danger" aria-label="required">*</span>
}
    </label>

    <div class="input-container" role="combobox" [attr.aria-expanded]="showCalendar">
        <input type="text" [id]="'date-input-' + label" [formControl]="$any(control)" [placeholder]="placeholder"
            [attr.data-id]="dataId" [disabled]="control.disabled"
            [attr.aria-describedby]="control.invalid && (control.dirty || control.touched) ? 'error-' + label : null"
            aria-label="Date input, format MM/DD/YYYY" (blur)="onInputBlur()" (click)="toggleCalendar()"
            (keydown.enter)="toggleCalendar()" (keydown.space)="toggleCalendar(); $event.preventDefault()"
            autocomplete="off" />
        <i class="fa fa-calendar" (click)="control.disabled ? null : toggleCalendar()"
            (keydown.enter)="toggleCalendar()" (keydown.space)="toggleCalendar(); $event.preventDefault()" tabindex="0"
            role="button" aria-label="Open calendar" [attr.aria-expanded]="showCalendar"
            [attr.aria-disabled]="control.disabled" [class.disabled]="control.disabled"></i>
    </div>

    @if (showCalendar) {
<div class="calendar" role="dialog" aria-label="Calendar" [attr.aria-modal]="true">

        <div class="calendar-header">
            <button type="button" (click)="changeMonth(-1)" aria-label="Previous month" tabindex="0">
                <i class="fa fa-chevron-left" aria-hidden="true"></i>
            </button>

            <div class="month-year">
                <select [value]="selectedMonth" (change)="onMonthChange($any($event.target).value)"
                    aria-label="Select month">
                    @for (month of months; track month; let i = $index) {
<option [value]="i">
                        {{ month }}
                    </option>
}
                </select>
                <select [value]="selectedYear" (change)="onYearChange($any($event.target).value)" aria-label="Select year">
                    @for (year of years; track year) {
<option [value]="year">
                        {{ year }}
                    </option>
}
                </select>
            </div>

            <button type="button" (click)="changeMonth(1)" aria-label="Next month" tabindex="0">
                <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
        </div>

        <div class="weekdays" role="row">
            @for (day of weekDays; track day) {
<div role="columnheader">{{ day }}</div>
}
        </div>

        <div class="days" role="grid">
            @for (date of calendarDays; track date; let i = $index) {
<div role="gridcell" [class.today]="isToday(date)"
                [class.selected]="isSelected(date)" [class.empty]="!date" [attr.tabindex]="date ? 0 : -1"
                [attr.aria-label]="date ? formatDate(date) : 'Empty'" [attr.aria-selected]="isSelected(date)"
                (click)="selectDate(date)" (keydown.enter)="selectDate(date)"
                (keydown.space)="selectDate(date); $event.preventDefault()">
                {{ date ? date.getDate() : '' }}
            </div>
}
        </div>
    </div>
}

    @if (control.invalid && (control.dirty || control.touched)) {
<div class="text-danger error-message"
        [id]="'error-' + label" role="alert" aria-live="polite">
        {{ getErrorMessage() }}
    </div>
}
</div>